import { Controller } from 'stimulus';

// Shows the options textarea only for field types whose answer is picked from
// a predefined list (list, radio, multiple_choice).
export default class extends Controller {
  static targets = ['fieldType', 'options'];

  static OPTION_TYPES = ['list', 'radio', 'multiple_choice'];

  connect() {
    this.toggleOptions();
  }

  toggleOptions() {
    if (!this.hasFieldTypeTarget || !this.hasOptionsTarget) return;

    const usesOptions = this.constructor.OPTION_TYPES.includes(this.fieldTypeTarget.value);
    this.optionsTarget.classList.toggle('d-none', !usesOptions);
  }
}
